import { render, staticRenderFns } from "./AssetPurchaseReport.vue?vue&type=template&id=d0f35fb4&"
import script from "./AssetPurchaseReport.vue?vue&type=script&lang=ts&"
export * from "./AssetPurchaseReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports